import Param from '../../param';
import effectManager from '../effect';
import autoAnimationManager from '../autoAnimation';
import animationManager from '../animation';

let param = new Param();
let effect;
let autoAnimation;

/* ---------------------------------------

    -- スクロール位置で発火するやつはここ

--------------------------------------- */
export default class ScrollAnimation{
    constructor(pageID){

        effect = new effectManager();
        autoAnimation = new autoAnimationManager();

        this.type = (window.innerWidth <= 320 && $('html.mobile')[0])? 'se':'other';

        this.$target = $('.js__tsc');
        this.scPoint = [];
        this.scPointFlg = [];
        this.scNum = this.$target.length;

        if(pageID != 'reuse' || this.type != 'se'){
            effect.splitText($(".js__tsc-splittext"),"set");
            effect.scShow($(".js__tsc-show"),"set");
            effect.scShowSlow($(".js__tsc-show__slow"),"set");
            effect.panel($(".js__tsc-panel"),"set");
        }

        this.resize();

        this.status = {
            comp : false, /* 全部処理が終わったか */
            rem  : this.$target.not(".is-show").length /* 表示していないセンテンスの数 */
        }

        this.h;

    }

    init(pageID){

        this.pageID = pageID;
        this.type = (window.innerWidth <= 320 && $('html.mobile')[0])? 'se':'other';

        this.$target = $('.js__tsc');
        this.scPoint = [];
        this.scPointFlg = [];
        this.scNum = this.$target.length;

        if(this.pageID != 'reuse' || this.type != 'se'){
            effect.splitText($(".js__tsc-splittext"),"set");
            effect.scShow($(".js__tsc-show"),"set");
            effect.scShowSlow($(".js__tsc-show__slow"),"set");
            effect.panel($(".js__tsc-panel"),"set");
        }

        this.resize();


        this.status = {
            comp : false, /* 全部処理が終わったか */
            rem  : this.$target.not(".is-show").length /* 表示していないセンテンスの数 */
        }

        this.h;
        
    }

    check(inc,$container){

        // if(this.status.comp) return;
        if(this.pageID == 'reuse' && this.type == 'se') return

        if(this.status.rem === 0) return;

        if(this.$target){
            for(var i=0; this.scNum>i; i++){

                if(this.scPoint[i] < inc && !this.$target.eq(i).hasClass('is-show')) {

                    let $scp = this.$target.eq(i);
                    if(!this.scPointFlg[i]){
                        this.scPointFlg[i] = true;
                        $scp.addClass("is-show");

                        let _$splitText = $scp.find(".js__tsc-splittext >* >*");
                        let _$show = $scp.find(".js__tsc-show");
                        let _$showSlow = $scp.find(".js__tsc-show__slow");
                        let _$panel = $scp.find(".js__tsc-panel");

                        if(_$splitText[0]) effect.splitText(_$splitText,"show");
                        if(_$show[0]) effect.scShow(_$show,"show");
                        if(_$showSlow[0]) effect.scShowSlow(_$showSlow,"show");
                        if(_$panel[0]) effect.panel(_$panel,"show");

                        if(i==this.$target.length-1){
                            this.status.comp = true;
                            this.status.rem = this.$target.not(".is-show").length;
                        }


                    }

                }

            }

        }

    }

    resize (winH) {

        this.h = winH;

        if(this.$target){
            // if(this.status.comp) return;
            let _minusPoint = (Useragnt.pc)?winH/1.5:winH*2;
            this.scPoint = [];
            for( var i=0; i<this.scNum; i++) {

                let $scp = this.$target.eq(i);

                if(param.displayType === 'pc' && $("#top")[0] || param.displayType === 'tablet' && $("#top")[0]) {
                    this.scPoint[i] = $scp.offset().left - _minusPoint;
                }else{
                    this.scPoint[i] = $scp.offset().top - _minusPoint;
                }
            }
        }

        this.type = (window.innerWidth <= 320 && $('html.mobile')[0])? 'se':'other';

    }
}